module.exports = __webpack_public_path__ + "assets/img/ptp05.680fdf34.png";